import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Button,
  Typography,
  Grid,
  Chip,
  Avatar,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import QrCodeIcon from '@mui/icons-material/QrCode2';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import QuizIcon from '@mui/icons-material/Quiz';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const TEMPLATES = [
  {
    id: 'steps-challenge',
    title: 'Wyzwanie krokowe',
    description: 'Wspólny lub indywidualny cel kroków z synchronizacją zdrowia.',
    icon: <DirectionsRunIcon />,
    color: '#00c875',
    tags: ['Aktywność', 'Zdrowie'],
  },
  {
    id: 'qr-event',
    title: 'Wydarzenie firmowe z QR',
    description: 'Rejestracja, limit miejsc i potwierdzenie obecności kodem QR.',
    icon: <QrCodeIcon />,
    color: '#579bfc',
    tags: ['Wydarzenie', 'QR'],
  },
  {
    id: 'contest',
    title: 'Konkurs ze zgłoszeniami',
    description: 'Pracownicy zgłaszają prace, moderator akceptuje, potem głosowanie.',
    icon: <PhotoCameraIcon />,
    color: '#ff3d57',
    tags: ['Konkurs', 'Głosowanie'],
  },
  {
    id: 'quiz',
    title: 'Quiz / ankieta',
    description: 'Krótki quiz edukacyjny lub ankieta aktywizacyjna z punktacją.',
    icon: <QuizIcon />,
    color: '#ffcc00',
    tags: ['Edukacja', 'Quiz'],
  },
  {
    id: 'volunteering',
    title: 'Wolontariat / CSR',
    description: 'Inicjatywa zespołowa z zapisami i potwierdzeniem udziału.',
    icon: <VolunteerActivismIcon />,
    color: '#6c6cff',
    tags: ['CSR', 'Zespół'],
  },
];

function CampaignTemplates() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Wybierz szablon kampanii
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Rozpocznij od gotowego szablonu i dostosuj szczegóły do swojej organizacji.
      </Typography>

      <Grid container spacing={3}>
        {TEMPLATES.map((template) => (
          <Grid item xs={12} sm={6} lg={4} key={template.id}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s, transform 0.2s',
                '&:hover': {
                  boxShadow: 4,
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={() => navigate(`/campaigns/new?template=${template.id}`)}
            >
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Avatar
                  sx={{
                    bgcolor: `${template.color}15`,
                    color: template.color,
                    width: 48,
                    height: 48,
                    mb: 2,
                  }}
                >
                  {template.icon}
                </Avatar>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {template.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {template.description}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                  {template.tags.map((tag) => (
                    <Chip key={tag} label={tag} size="small" variant="outlined" />
                  ))}
                </Box>
              </CardContent>
              <Box sx={{ p: 2, pt: 0, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  endIcon={<ArrowForwardIcon />}
                  size="small"
                  sx={{ textTransform: 'none', fontWeight: 600 }}
                  onClick={(e) => { e.stopPropagation(); navigate(`/campaigns/new?template=${template.id}`); }}
                >
                  Dostosuj
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default CampaignTemplates;
